import 'core-js/modules/es.symbol';
import 'core-js/modules/es.symbol.description';
import 'core-js/modules/es.symbol.to-primitive';
import 'core-js/modules/es.array.join';
import 'core-js/modules/es.date.to-primitive';
import 'core-js/modules/es.number.constructor';
import 'core-js/modules/es.object.to-string';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.string.match';
import 'core-js/modules/es.string.replace';
import 'core-js/modules/es.string.split';
import { isWorldReadyInstance } from '@paypalcorp/worldready-core';
import { assert } from 'yaassertion';
import '@paypalcorp/globalize/dist/globalize/number';

function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var getMissingMetadataError = function getMissingMetadataError(path) {
  var message = "Missing WorldReady metadata, please refer to https://github.paypal.com/pages/Globalization-R/worldready-js/docs/about-load-worldready-data.html";
  if (path) {
    message += "\nPath: " + path;
  }
  return new Error(message);
};
function globalizeToWorldReadyError(error) {
  if (error.code === "E_MISSING_CLDR") {
    return getMissingMetadataError(error.stack);
  }
  return new Error(["Oops, internal error", error.message, error.stack].join("\n"));
}

/**
 * Note:
 * - Below, we "borrow code" from globalize since it doesn't export the resolved properties.
 *   https://github.com/globalizejs/globalize/blob/8f4f2bffed00231aa2f7f4f46c3a4687ace46ab6/src/number.js
 *   https://github.com/globalizejs/globalize/blob/8f4f2bffed00231aa2f7f4f46c3a4687ace46ab6/src/number/pattern-properties.js
 *   https://github.com/globalizejs/globalize/blob/8f4f2bffed00231aa2f7f4f46c3a4687ace46ab6/src/number/format-properties.js
 * - NOT using numberFormatter.runtimeArgs because it's NOT available when code is minified.
 *
 * TODO: Expose resolvedOptions() in globalize and reuse it here.
 */

function numberNumberingSystem(cldr) {
  var nu = cldr.attributes["u-nu"];
  if (nu) {
    if (nu === "traditio") {
      nu = "traditional";
    }
    if (["native", "traditional", "finance"].indexOf(nu) !== -1) {
      // Unicode locale extension `u-nu` is set using either (native, traditional or
      // finance). So, lookup the respective locale's numberingSystem and return it.
      return cldr.main(["numbers/otherNumberingSystems", nu]);
    }

    // Unicode locale extension `u-nu` is set with an explicit numberingSystem. Return it.
    return nu;
  }

  // Return the default numberingSystem.
  return cldr.main("numbers/defaultNumberingSystem");
}
function numberPattern(style, cldr) {
  if (style !== "decimal" && style !== "percent") {
    throw new Error("Invalid style");
  }
  return cldr.main(["numbers", style + "Formats-numberSystem-" + numberNumberingSystem(cldr), "standard"]);
}
var numberPatternRe = /^(('([^']|'')*'|[^*#@0,.E])*)(\*.)?((([#,]*[0,]*0+)(\.0*[0-9]*#*)?)|([#,]*@+#*))(E\+?0+)?(('[^']+'|''|[^*#@0,.E])*)$/;
function numberPatternProperties(pattern) {
  var fractionPattern, integerPattern, maximumFractionDigits, maximumSignificantDigits, minimumFractionDigits, minimumIntegerDigits, minimumSignificantDigits;
  pattern = pattern.match(numberPatternRe);
  if (!pattern) {
    throw new Error("Invalid pattern: " + pattern);
  }

  // Significant digit format
  {
    fractionPattern = pattern[8];
    integerPattern = pattern[7];
    if (fractionPattern) {
      // Minimum fraction digits, and rounding.
      fractionPattern.replace(/[0-9]+/, function (match) {
        minimumFractionDigits = match;
      });
      if (minimumFractionDigits) {
        minimumFractionDigits = minimumFractionDigits.length;
      } else {
        minimumFractionDigits = 0;
      }

      // Maximum fraction digits
      // 1: ignore decimal character
      maximumFractionDigits = fractionPattern.length - 1; /* 1 */
    } else {
      minimumFractionDigits = 0;
      maximumFractionDigits = 0;
    }

    // Minimum integer digits
    integerPattern.replace(/0+$/, function (match) {
      minimumIntegerDigits = match.length;
    });
  }
  return [0, 0, minimumIntegerDigits, minimumFractionDigits, maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits];
}
function numberFormatProperties(pattern, cldr, options) {
  var positivePattern, properties;
  function getOptions(attribute, propertyIndex) {
    if (attribute in options) {
      properties[propertyIndex] = options[attribute];
    }
  }
  options = options || {};
  pattern = pattern.split(";");
  positivePattern = pattern[0];
  properties = numberPatternProperties(positivePattern);
  if (options.compact) {
    // The compact digits number pattern is always `0+`, so override the following properties.
    // Note: minimumIntegerDigits would actually range from `0` to `000` based on the scale of
    // the value to be formatted, though we're always using 1 as a simplification, because the
    // number won't be zero-padded since we chose the right format based on the scale, i.e.,
    // we'd never see something like `003M` anyway.
    properties[2] = 1; // minimumIntegerDigits
    properties[3] = 0; // minimumFractionDigits
    properties[4] = 0; // maximumFractionDigits
    properties[5] = properties[6] = undefined; // minimumSignificantDigits & // maximumSignificantDigits
  }
  getOptions("minimumIntegerDigits", 2);
  getOptions("minimumFractionDigits", 3);
  getOptions("maximumFractionDigits", 4);
  getOptions("minimumSignificantDigits", 5);
  getOptions("maximumSignificantDigits", 6);

  // Normalize number of digits if only one of either minimumFractionDigits or
  // maximumFractionDigits is passed in as an option
  if ("minimumFractionDigits" in options && !("maximumFractionDigits" in options)) {
    // maximumFractionDigits = Math.max( minimumFractionDigits, maximumFractionDigits );
    properties[4] = Math.max(properties[3], properties[4]);
  } else if (!("minimumFractionDigits" in options) && "maximumFractionDigits" in options) {
    // minimumFractionDigits = Math.min( minimumFractionDigits, maximumFractionDigits );
    properties[3] = Math.min(properties[3], properties[4]);
  }
  return properties;
}
function resolvedOptions(globalize, options) {
  if (options === void 0) {
    options = {};
  }
  var pattern;
  var cldr = globalize.cldr;
  if (options.raw) {
    pattern = options.raw;
  } else {
    pattern = numberPattern(options.style || "decimal", cldr);
  }
  var properties = numberFormatProperties(pattern, cldr, options);
  var minimumIntegerDigits = properties[2],
    minimumFractionDigits = properties[3],
    maximumFractionDigits = properties[4],
    minimumSignificantDigits = properties[5],
    maximumSignificantDigits = properties[6];
  return {
    minimumIntegerDigits: minimumIntegerDigits,
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits,
    minimumSignificantDigits: minimumSignificantDigits,
    maximumSignificantDigits: maximumSignificantDigits
  };
}

/**
 * This class is a wrapper class on top of Griffin 2.0.
 */
var NumberFormat = /*#__PURE__*/function () {
  function NumberFormat(worldReady, options) {
    // Error Check: WorldReady Object
    if (process.env.NODE_ENV !== "production") {
      assert(isWorldReadyInstance(worldReady), "WorldReady object missing.");
    }
    try {
      this.numberFormatter = worldReady.globalize.numberFormatter(options);
      this.numberParser = worldReady.globalize.numberParser(options);
    } catch (error) {
      throw globalizeToWorldReadyError(error);
    }
    var resolvedOptionsCache;
    this._resolvedOptions = function () {
      if (!resolvedOptionsCache) {
        resolvedOptionsCache = resolvedOptions(worldReady.globalize, options);
      }
      return resolvedOptionsCache;
    };
  }

  /**
   * Errors handled by Globalize
   */
  var _proto = NumberFormat.prototype;
  _proto.format = function format(number) {
    return this.numberFormatter(number);
  }

  /**
   * Errors handled by Globalize
   */;
  _proto.parse = function parse(localizedNumber) {
    return this.numberParser(localizedNumber);
  };
  _proto.resolvedOptions = function resolvedOptions() {
    return this._resolvedOptions();
  };
  return NumberFormat;
}(); // Exposing number's resolvedOptions for reuse on CurrencyFormat.
_defineProperty(NumberFormat, "_resolvedOptions", resolvedOptions);

export { NumberFormat };
